App.NotificationFilters = (function() {
  function init() {
    if (!(window.$ && window.$.fn && typeof window.$.fn.select2 === 'function')) {
      return;
    }

    var selects = window.$('.js-notification-multiselect');
    if (!selects.length) { return; }

    selects.select2({
      width: '100%',
      allowClear: true,
      placeholder: 'Select one or more options'
    });
  }

  return {
    init: init
  };
})();

